import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { AwsSensorController } from '../controller/AwsSensorController';

export class AwsSensorComponent extends BaseSensorWebComponent {
  public controller!: AwsSensorController;

  constructor() {
    super();
    this.sensorType = SensorType.AWS;
    this.initialSetup({
      controllerConstructor: AwsSensorController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
